import { useLayoutEffect, useState } from "react";

export const OVERLAY_BASE_Z = 70;

type Entry = { setZIndex: (zIndex: number) => void };

const stack: Entry[] = [];

function renumber() {
  stack.forEach((entry, index) => {
    entry.setZIndex(OVERLAY_BASE_Z + index);
  });
}

export default function useOverlayLayer(open: boolean): number {
  const [zIndex, setZIndex] = useState(OVERLAY_BASE_Z);

  useLayoutEffect(() => {
    if (!open) return;

    const entry = { setZIndex };
    stack.push(entry);
    renumber();
    return () => {
      const index = stack.indexOf(entry);
      if (index !== -1) stack.splice(index, 1);
      renumber();
    };
  }, [open]);

  return zIndex;
}
